export default "/images/vendor/flag-icons/flags/4x3/aw.svg?5833f1365defb17730fccd0b013c2488";